module.exports = __webpack_public_path__ + "images/emoji/white_medium_small_square.2dd284f2214d770af86b.png";